
export type RecurrenceUnit =
  | "minute"
  | "hour"
  | "day"
  | "week"
  | "month"
  | "year";

export type RetryLimitUnit = "minutes" | "hours"; // Note: must be a valid moment.js unit suitable for moment.subtract()

export interface Schedule {
  isNow?: boolean;
  dueDate?: string;
  isTimeValid?: boolean;
  isRecurring?: boolean;
  recurrenceQuantity?: number;
  recurenceUnit?: RecurrenceUnit;
  cancelIfReceived?: boolean;
  rruleset?: string;
  calendarMessage?: boolean;
  retryLimitUnit?: RetryLimitUnit;
  retryLimitDuration?: number;
}

export enum MessageState {
  pending,
  sending,
  editing,
}

/**
 * Input-form Asset shape used by the message editor / chatbot / bulk-dashboard
 * editors at WRITE time, where `type` must be a concrete string (the UI
 * always knows the media kind it just selected).
 *
 * The PERSISTED shape is bt-common's `MessageAsset` (bt/user-message.ts),
 * which widens `name` + `type` to `string | null | undefined` for back-compat
 * with older docs. Consumers reading a persisted asset (off a `UserMessage`)
 * must use `MessageAsset`, NOT this type. Tracked: #41.
 */
export interface Asset {
  name: string;
  type: string;
  url: string;
}

export type ActiveNewTaskRow = {
  groupId: string;
  parentTaskId?: string
}

export type PreservedGroup = {
  _id: string,
  boardId?: string,
  deleted: boolean
}
export type PreservedBoard = {
  _id: string,
  deleted: boolean
}

export type ActionsReduerData = {
  group: PreservedGroup,
}


export interface CheckAuthParams {
  wid?: string;
  accessToken?: string;
  email?: string;
}

export interface SubscriptionSuccessOptions {
  shareASaleUrl: string;
}

export enum GlobalTasksPanelState {
  closed,
  openSingle,
  openAll,
}

export type MenuOptionType =
  | "socketConnectionStatus"
  | "openChatByPhoneNumber"
  | "broadcastBulkCampaign"
  | "scheduledMessages"

export interface MenuOption {
  icon?: JSX.Element;
  text?: string;
  type: MenuOptionType;
}
export const EmittedPathList = ["create", "patch", "delete"];
export type EmittedPath = typeof EmittedPathList[number];
export interface UpdateEvent<T = any> {
  path: string;
  method: string;
  entity: T;
  callback?: (response: any) => void;
  _messageId?: number;
  _roomId?: string;
}

export interface QREvent {
  owner: string;
  qr: string;
}


export type Id = string;
export type NullableId = Id | null;